import * as Dtos from '../api/dtos';

export const hasPermission = (
    permissions: Dtos.Permissions[] | undefined,
    permission: Dtos.Permissions
) => {
    return permissions?.some(currPermission => currPermission === permission) ?? false;
}